export default "__VITE_ASSET__08527d3c__"